import { type FC, useContext } from "react"

import { AppContext } from "../providers/AppProvider"
import { ModalBase } from "./ModalBase"
import UbiqButton, { UbiqButtonSize, UbiqButtonType } from "./UbiqButton"

const LEGAL_MODAL_PANEL_STYLES =
  "w-[calc(100vw-32px)] sm:w-[960px] max-w-[960px] pt-14 sm:pt-16 pb-6 h-[80vh] sm:h-[740px]"

export const PPModal: FC<{
  isOpen: boolean
}> = ({ isOpen }) => {
  const { hidePPModal } = useContext(AppContext)

  return (
    <ModalBase
      addBgOpacity
      dialogPanelStyles={LEGAL_MODAL_PANEL_STYLES}
      onClose={hidePPModal}
      show={isOpen}
      showCloseIcon
      title={""}
    >
      <div className="flex flex-col h-full">
        <div className="iframe-container flex-1 min-h-0 w-full">
          <iframe className="h-full" src="/privacy" title="Privacy Policy" width="100%"></iframe>
        </div>
        <div className="flex-shrink-0 pt-4 pb-2 px-4">
          <UbiqButton
            buttonType={UbiqButtonType.LIGHT}
            onClick={hidePPModal}
            size={UbiqButtonSize.MEDIUM}
            styles="mx-auto"
            title="GOT IT"
          />
        </div>
      </div>
    </ModalBase>
  )
}
